import { render } from "./results-board.vue?vue&type=template&id=41e82316&scoped=true&ts=true"
import script from "./results-board.vue?vue&type=script&lang=ts"
export * from "./results-board.vue?vue&type=script&lang=ts"

import "./results-board.vue?vue&type=style&index=0&id=41e82316&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41e82316"]])

export default __exports__